import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLingui } from '@lingui/react/macro';

interface CopyButtonProps {
  value: string;
  fieldId: string;
  copyLabel?: string;
  isCopied: boolean;
  isAbsolutePositioned?: boolean;
  onCopy: (value: string, fieldId: string) => void;
}

export const CopyButton = ({
  value,
  fieldId,
  copyLabel,
  isCopied,
  isAbsolutePositioned = true,
  onCopy,
}: CopyButtonProps) => {
  const { t } = useLingui();

  const handleClick = () => {
    if (value) {
      onCopy(value, fieldId);
    }
  };

  const baseClasses =
    'vai-w-8 vai-h-8 vai-flex vai-items-center vai-justify-center hover:vai-bg-gray-100 vai-rounded vai-opacity-0 group-hover:vai-opacity-100 vai-transition-opacity';
  const absoluteClasses = isAbsolutePositioned
    ? 'vai-absolute vai-right-2 vai-top-1/2 vai-transform vai--translate-y-1/2'
    : '';

  return (
    <button
      type="button"
      className={`${baseClasses} ${absoluteClasses}`}
      onClick={handleClick}
      title={isCopied ? t`Copied!` : copyLabel || t`Copy`}
    >
      <FontAwesomeIcon
        icon={isCopied ? faCheck : faCopy}
        className={`vai-w-4 vai-h-4 ${
          isCopied ? 'vai-text-green-600' : 'vai-text-muted-foreground'
        }`}
      />
    </button>
  );
};
